function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { withGenericConfig } from "contexts/generic-config-context";
import { updateClusterFooterLinks } from "client/services/cluster-config-service/cluster-config-service";
import ShortFooter from "components/core/short-footer/short-footer";
import DefaultProps from "./default-props";
import FooterCategoryComponent from "./footer-category/footer-category-component";
import { StyledDesktopFooterContainer, StyledMobileFooterContainer, StyledFooter } from "./long-footer.scss";
import { SocialFooterLinks, FOOTER_LINKS } from "/constants/links";
import FooterBottomBarComponent from "./footer-bottom-bar/footer-bottom-bar-component";
import { useEffect } from "react";
const Footer = (props)=>{
    const { translate, pageClusterConfig, useProductMiniSiteConfig, setStartShowingStickyHeader, isInView } = props;
    useEffect(()=>{
        setStartShowingStickyHeader(!isInView);
    }, [
        isInView,
        setStartShowingStickyHeader
    ]);
    const LONG_FOOTER = "long";
    const renderShortFooter = ()=>{
        return /*#__PURE__*/ _jsx(ShortFooter, _object_spread({}, props));
    };
    const renderLongFooter = ()=>{
        const links = pageClusterConfig ? updateClusterFooterLinks(pageClusterConfig, FOOTER_LINKS, {
            useProductMiniSiteConfig
        }) : FOOTER_LINKS;
        return /*#__PURE__*/ _jsxs(StyledFooter, {
            className: "footer-container",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ _jsx("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "categories-container",
                            children: [
                                links.monday && /*#__PURE__*/ _jsx("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                        title: translate(links.monday.title),
                                        links: links.monday.links,
                                        hasMondayLogoTitle: links.monday.hasMondayLogoTitle
                                    })
                                }),
                                (links.aiWork || links.features) && /*#__PURE__*/ _jsx("div", {
                                    className: "category-container features",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "categories-colmmn-wrapper",
                                        children: [
                                            links.aiWork && /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                                title: translate(links.aiWork.title),
                                                links: links.aiWork.links
                                            }),
                                            links.features && /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                                title: translate(links.features.title),
                                                links: links.features.links
                                            })
                                        ]
                                    })
                                }),
                                links.products && /*#__PURE__*/ _jsx("div", {
                                    className: "category-container products",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "categories-colmmn-wrapper",
                                        children: [
                                            /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                                title: translate(links.products.title),
                                                links: links.products.links
                                            }),
                                            /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                                title: translate(links.moreByMonday.title),
                                                links: links.moreByMonday.links
                                            })
                                        ]
                                    })
                                }),
                                links.useCases && /*#__PURE__*/ _jsx("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                        title: translate(links.useCases.title),
                                        links: links.useCases.links
                                    })
                                }),
                                links.ourTeam && /*#__PURE__*/ _jsx("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                        title: translate(links.ourTeam.title),
                                        links: links.ourTeam.links
                                    })
                                }),
                                links.resources && /*#__PURE__*/ _jsx("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                        title: translate(links.resources.title),
                                        links: links.resources.links
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(FooterBottomBarComponent, {
                    SocialFooterLinks: SocialFooterLinks,
                    footerType: LONG_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(StyledDesktopFooterContainer, {
                className: "footer-desktop-wrapper",
                children: renderLongFooter()
            }),
            /*#__PURE__*/ _jsx(StyledMobileFooterContainer, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
export default withGenericConfig(Footer);
Footer.defaultProps = DefaultProps;
